import { isObject } from "@next-core/utils/general";
import { symbolForRootRuntimeContext } from "./secret_internals.js";
import { childrenToSlots } from "./Renderer.js";
export function setupRootRuntimeContext(bricks, runtimeContext, shallow) {
  function walk(props) {
    if (!isObject(props) || typeof props === "function") {
      return;
    }
    if (Array.isArray(props)) {
      props.map(walk);
      return;
    }
    for (const [key, value] of Object.entries(props)) {
      if (isObject(value) && key === "useBrick") {
        if (Array.isArray(value)) {
          value.forEach(v => setupBrick(v, true));
        } else {
          setupBrick(value, true,
          // For inside useBrick, we always need to setup recursively.
          true);
        }
      } else {
        walk(value);
      }
    }
  }
  function setupBrick(brick, inUseBrick, forceRecursive) {
    if (inUseBrick) {
      brick[symbolForRootRuntimeContext] = runtimeContext;
    }
    walk(brick.properties);
    if (shallow && !forceRecursive) {
      return;
    }
    const transpiledSlots = childrenToSlots(brick.children, brick.slots);
    for (const slotConf of Object.values(transpiledSlots !== null && transpiledSlots !== void 0 ? transpiledSlots : {})) {
      for (const brick of (_slotConf$bricks = slotConf.bricks) !== null && _slotConf$bricks !== void 0 ? _slotConf$bricks : []) {
        var _slotConf$bricks;
        setupBrick(brick, inUseBrick);
      }
    }
  }
  for (const brick of bricks) {
    setupBrick(brick);
  }
}
//# sourceMappingURL=setupRootRuntimeContext.js.map